import axiosNew from '../../helpers/axios'

const BASE = 'users/collections'

const pickParams = (params = {}) => {
    const next = {}
    if (params.skip != null) next.skip = params.skip
    if (params.limit != null) next.limit = params.limit
    if (params.search) next.search = params.search
    if (params.sort) next.sort = params.sort
    if (params.order) next.order = params.order
    if (typeof params.isDeleted === 'boolean') {
        next.isDeleted = params.isDeleted
    }
    return next
}

export const fetchCollections = (params = {}) =>
    axiosNew({
        url: BASE,
        method: 'GET',
        params: pickParams(params),
    })

export const fetchCollectionById = (id) =>
    axiosNew({
        url: `${BASE}/${id}`,
        method: 'GET',
    })

export const createCollection = ({ name, description }) =>
    axiosNew({
        url: BASE,
        method: 'POST',
        data: { name, description },
    })

export const updateCollection = ({ id, name, description, isDeleted }) =>
    axiosNew({
        url: `${BASE}/${id}`,
        method: 'PATCH',
        data: {
            ...(name !== undefined ? { name } : {}),
            ...(description !== undefined ? { description } : {}),
            ...(typeof isDeleted === 'boolean' ? { isDeleted } : {}),
        },
    })

export const deleteCollection = (id) =>
    axiosNew({
        url: `${BASE}/${id}`,
        method: 'DELETE',
    })

export const fetchCollectionMembers = (collectionId, params = {}) =>
    axiosNew({
        url: `${BASE}/${collectionId}/members`,
        method: 'GET',
        params: pickParams(params),
    })

export const fetchCollectionMemberCandidates = (collectionId, params = {}) =>
    axiosNew({
        url: `${BASE}/${collectionId}/members/candidates`,
        method: 'GET',
        params: pickParams(params),
    })

export const addCollectionMember = ({ collectionId, userIds, role }) =>
    axiosNew({
        url: `${BASE}/${collectionId}/members`,
        method: 'POST',
        data: {
            userIds: userIds,
            role,
        },
    })

export const updateCollectionMemberRole = ({ collectionId, userId, role }) =>
    axiosNew({
        url: `${BASE}/${collectionId}/members/${userId}`,
        method: 'PATCH',
        data: { role },
    })

export const removeCollectionMember = ({ collectionId, userId }) =>
    axiosNew({
        url: `${BASE}/${collectionId}/members/${userId}`,
        method: 'DELETE',
    })
